export const PERMISSIONS = {
  ALL: "ALL",

  CREATE_PROPOSAL: "CREATE_PROPOSAL",
  UPLOAD_CONTRACT_SCOPE: "UPLOAD_CONTRACT_SCOPE",

  VIEW_COMPANY_STAFF: "VIEW_COMPANY_STAFF",
  MANAGE_COMPANY_STAFF: "MANAGE_COMPANY_STAFF",
  VIEW_COMPANY: "VIEW_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  DELETE_COMPANY: "DELETE_COMPANY",
  MANAGE_BILLING: "MANAGE_BILLING",
  VIEW_JOBS: "VIEW_JOBS",
  RESPOND_JOB: "RESPOND_JOB",

  VIEW_CONTRACT: "VIEW_CONTRACT",
  CREATE_CONTRACT: "CREATE_CONTRACT",
  UPDATE_CONTRACT: "UPDATE_CONTRACT",
  DELETE_CONTRACT: "DELETE_CONTRACT",
  SIGN_CONTRACT: "SIGN_CONTRACT",
  MANAGE_CONTRACT_MILESTONE: "MANAGE_CONTRACT_MILESTONE",
  MANAGE_CHANGE_ORDER: "MANAGE_CHANGE_ORDER",
  MANAGE_SUBCONTRACT: "MANAGE_SUBCONTRACT",
};

